<template>
  <div class="bg-wrap" v-if="data">
    <a-row type="flex" justify="end" class="profileRow">
      <a-col :span="3">
        <a-button type="primary" class="backToFairBtn" @click="goToExpo"
          >{{ $t("profile.backToFair") }}<a-icon type="right"
        /></a-button>
      </a-col>
    </a-row>
    <a-row type="flex" justify="center" class="profileRow">
      <a-col :span="24" :lg="6">
        <a-card class="profileCardLeft">
          <a-card-grid class="cardNoBorder" :hoverable="false">
            <div class="avatar-wrap">
              <img
                class="frame"
                :src="
                  imageBaseUrl +
                  '/api/users/' +
                  'pictureframe?rol_id=' +
                  data.rol_id +
                  '&type=circle' +
                  '&sid=' +
                  sid
                "
                alt=""
              />
              <a-badge
                :status="data.online ? 'success' : 'error'"
                title="online status"
                :offset="[-10, 100]"
                ><a-avatar
                  shape="circle"
                  icon="user"
                  :src="data.imageURL"
                  :size="120"
              /></a-badge>
            </div>
            <a-button type="default" class="profileTypeBtn" v-if="data.rol_name"
              ><b>{{ data.rol_name.toUpperCase() }}</b></a-button
            >
            <p class="profileSideHeadingCenter">
              {{ data.name }} {{ data.lastname }}
            </p>
          </a-card-grid>
          <a-card-grid class="cardNoBorderP16" :hoverable="false">
            <span class="blockM16">
              <a-icon type="environment" :style="{ color: '#001529' }" />
              <p class="iconP">{{ cityCountry }}</p>
            </span>
            <span class="blockM16">
              <a-icon type="bank" :style="{ color: '#001529' }" />
              <p class="iconP">{{ workplace }}</p>
            </span>
            <span class="blockM16">
              <a-icon type="bank" :style="{ color: '#001529' }" />
              <p class="iconP">{{ uni }}</p>
            </span>
          </a-card-grid>
          <a-card-grid class="w100p16" :hoverable="false">
            <p class="profileSideHeading">
              {{ $t("profile.socialMediaAndWebpage") }}
            </p>
            <a-icon
              type="facebook"
              theme="filled"
              :style="{ fontSize: '17px', color: '#2295D6' }"
              @click="redirect(data.socials.facebook)"
            />
            <a-icon
              type="twitter-square"
              theme="filled"
              :style="{
                fontSize: '17px',
                color: '#2295D6',
                marginLeft: '20px',
              }"
              @click="redirect(data.socials.twitter)"
            />
            <a-icon
              type="linkedin"
              theme="filled"
              :style="{
                fontSize: '17px',
                color: '#2295D6',
                marginLeft: '20px',
              }"
              @click="redirect(data.socials.linkedIn)"
            />
            <!-- HIDDEN BY REQUEST 18.11.2021 <a-icon
              type="api"
              theme="filled"
              :style="{
                fontSize: '17px',
                color: '#2295D6',
                marginLeft: '20px',
              }"
              @click="redirect(data.socials.website)"
            /> -->
          </a-card-grid>
          <a-card-grid class="w100p16" :hoverable="false">
            <p class="profileSideHeading">
              {{ $t("profile.contact") }} {{ data.name }}
            </p>
            <!--HIDDEN BY REQUEST 18.11.2021 <a-icon
              type="message"
              theme="filled"
              :style="{ fontSize: '17px', color: '#2295D6' }"
              @click="gotoEmail()"
            /> 
            <a-icon
              type="phone"
              theme="filled"
              :style="{
                fontSize: '17px',
                color: '#2295D6',
                marginLeft: '20px',
              }"
              @click="gotoPhone()"
            /> -->
            <a-icon
              type="wechat"
              theme="filled"
              :style="{
                fontSize: '17px',
                color: '#2295D6',
                marginLeft: '20px',
              }"
              v-if="profileId"
              @click="openChatModalToDM"
            />
            <!-- HIDDEN BY REQUEST 18.11.2021 <a-icon
              type="video-camera"
              theme="filled"
              :style="{
                fontSize: '17px',
                color: '#2295D6',
                marginLeft: '20px',
              }"
              v-if="
                profileId &&
                !(Number(profileId) === Number(userId)) &&
                isLoggedIn &&
                Number(globalFairConfig.FC_CALL) === 1
              "
              @click="emitVideoCall"
            /> -->
          </a-card-grid>
          <!-- HIDDEN BY REQUEST 18.11.2021 <a-card-grid class="w100p16" :hoverable="false">
            <p class="profileSideHeading">
              {{ $t("profile.scheduleAMeeting") }}
            </p>
            <a-icon
              type="calendar"
              theme="filled"
              :style="{ fontSize: '17px', color: '#2295D6' }"
              @click="redirect(data.meeting.calendly)"
            />
          </a-card-grid> -->
          <a-card-grid class="w100p16" :hoverable="false">
            <a-button
              type="default"
              class="editLinksBtn"
              v-if="!profileId"
              @click="openEditLinks()"
              >{{ $t("profile.editLinks") }}</a-button
            >
            <a-button
              type="primary"
              class="backToFairBtn mobile"
              @click="goToExpo"
              >{{ $t("profile.backToFair") }}<a-icon type="right"
            /></a-button>
          </a-card-grid>
        </a-card>
      </a-col>
      <a-col :span="24" :lg="18">
        <a-card class="profileCardRight">
          <h2 class="profileMainHeading">{{ $t("profile.shortBio") }}</h2>
          <a-button
            type="default"
            class="editProfileBtn"
            @click="openEditProfile()"
            v-if="userId == data.id"
            >{{ $t("profile.editProfile") }}</a-button
          >
          <p class="profileMainContent">{{ data.bio }}</p>
        </a-card>
        <a-card v-if="badges.length > 0" class="badges">
          <UserBadges :badges="badges" :userPoints="userPoints" />
        </a-card>
      </a-col>
    </a-row>
    <!-- OLD DESIGN 
	<div class="view-profile-wrap" v-if="data && !mobile">
		<div class="pic-socials-wrap">
			<div class="pic-dot-wrap">
				<div class="pic-wrap">
					<img :src="data.imageURL" draggable="false" />
				</div>
				<div class="green-dot" v-if="data.online"></div>
			</div>
			<div class="open-chat" @click="openChatModalToDM">
				<span>{{$t('profile.openChat')}}</span>
				<span class="material-icons">arrow_forward_ios</span>
			</div>
			<div class="socials-wrap">
				<span>{{$t('profile.socialMediaAndWebpage')}}</span>
				<div>
					<img
						:class="{'lower-opacity': !data.socials.facebook}"
						@click="redirect(data.socials.facebook)"
						:src="$images.facebookB"
						draggable="false"
					/>
					<img
						:class="{'lower-opacity': !data.socials.twitter}"
						@click="redirect(data.socials.twitter)"
						:src="$images.twitterB"
						draggable="false"
					/>
					<img
						:class="{'lower-opacity': !data.socials.linkedIn}"
						@click="redirect(data.socials.linkedIn)"
						:src="$images.linkedinB"
						draggable="false"
					/>
					<img
						:class="{'lower-opacity': !data.socials.website}"
						@click="redirect(data.socials.website)"
						:src="$images.websiteB"
						draggable="false"
					/>
				</div>
			</div>
			<div class="contacts-wrap">
				<span>{{$t('profile.contact')}} {{data.name}}</span>
				<div>
					<img
						:class="{'lower-opacity': !data.contacts.email}"
						@click="gotoEmail()"
						:src="$images.mailB"
						draggable="false"
					/>
					<img
						:class="{'lower-opacity': !data.contacts.phone}"
						@click="gotoPhone()"
						:src="$images.phoneB"
						draggable="false"
					/>
          <img :class="{'lower-opacity': !webRTC}"
            @click="emitVideoCall"
            :src="$images.phoneCall"
            draggable="false"
          />
					<div class="filler">filler</div>
				</div>
			</div>
			<div class="meeting-wrap">
				<span>{{$t('profile.scheduleAMeeting')}}</span>
				<div>
					<img
						:class="{'lower-opacity': !data.meeting.calendly}"
						@click="redirect(data.meeting.calendly)"
						:src="$images.calendly"
						draggable="false"
					/>
				</div>
			</div>
			<div class="edit-links">
				<button v-if="!profileId" @click="openEditLinks()">{{$t('profile.editLinks')}}</button>
			</div>
			<div class="report-button" v-if="profileId" @click="openReportModal">
				<img :src="$images.flag" draggable="false" />
				<span>{{$t('profile.reportProfile')}}</span>
			</div>
		</div>
		<div class="info-goals-interests-wrap">
			<div class="navbar">
				<div class="back-link" @click="goToExpo">
					<span>{{$t('profile.backToFair')}}</span>
					<span class="material-icons">keyboard_backspace</span>
				</div>
			</div>
			<div class="general-info">
				<div class="type">{{data.type.toUpperCase()}}</div>
				<div class="full-name">{{data.name}} {{data.lastname}}</div>
				<div class="detail-item">
					<div class="item-wrap">
						<div class="img-wrap">
							<img :src="$images.location" draggable="false" />
						</div>
						<span :title="cityCountry">{{cityCountry}}</span>
					</div>
				</div>
				<div class="detail-item">
					<div class="item-wrap">
						<div class="img-wrap">
							<img :src="$images.job" draggable="false" />
						</div>
						<span
							:class="{'opacity-06': workplace === 'No Current Position'}"
							:title="workplace"
						>{{workplace}}</span>
					</div>
				</div>
				<div class="detail-item edit">
					<div class="item-wrap">
						<div class="img-wrap">
							<img :src="$images.uni" draggable="false" />
						</div>
						<span :class="{'opacity-06': uni === 'No Information Available'}" :title="uni">{{uni}}</span>
					</div>
					<button class="edit-profile" v-if="!profileId" @click="openEditProfile()">{{$t('profile.editProfile')}}</button>
				</div>
			</div>
			<div class="bio" v-if="data.bio">
				<span>{{$t('profile.shortBio')}}</span>
				<span>{{data.bio}}</span>
			</div>

			<div class="selected-warp">
				<div v-for="(list, title) in data.selected" :key="title" class="multi-select">
					<span>{{title}}</span>
					<div class="items-wrap">
						<div v-for="(text, i) in list" :key="i" :class="{'test': testIfOdd(title)}">{{text}}</div>
					</div>
				</div>
			</div>
		</div> -->

    <transition name="chat-fade">
      <div
        class="background-dim"
        v-if="isEditLinksOpen || isEditProfileOpen || isReportOpen"
      ></div>
    </transition>
    <transition name="chat-fade">
      <editlinks
        v-if="isEditLinksOpen"
        :links="links"
        @close="closeEditLinks"
      />
    </transition>
    <transition name="chat-fade">
      <editprofile v-if="isEditProfileOpen" @close="closeEditProfile" />
    </transition>
    <transition name="chat-fade">
      <reportmodal
        v-if="isReportOpen"
        @close="closeReportModal"
        :reportdata="reportData"
      />
    </transition>
    <!-- </div>
	<div
		class="view-profile-wrap"
		:class="{'mobile': mobile, 'landscape': orientation, 'portrait': !orientation}"
		v-else
	>
		<div class="mobile-background" v-if="mobile"></div>
		<div class="type-vertical" v-if="data">{{data.type.toUpperCase()}}</div>
		<div class="pic-dot-wrap" v-if="data">
			<div class="pic-wrap">
				<img :src="data.imageURL" draggable="false" />
			</div>
			<div class="green-dot" v-if="data.online"></div>
		</div>
		<div class="full-name" v-if="data">{{data.name}} {{data.lastname}}</div>
		<div class="open-chat" v-if="profileId && data" @click="openChatModalToDM">
			<span>{{$t('profile.openChat')}}</span>
			<img :src="$images.sendIconB" draggable="false" />
		</div>
		<button class="edit-profile" v-if="!profileId && data" @click="openEditProfile()">{{$t('profile.editProfile')}}</button>
		<div class="general-info" v-if="data">
			<div class="detail-item">
				<div class="item-wrap">
					<div class="img-wrap">
						<img :src="$images.location" draggable="false" />
					</div>
					<span :title="cityCountry">{{cityCountry}}</span>
				</div>
			</div>
			<div class="detail-item">
				<div class="item-wrap">
					<div class="img-wrap">
						<img :src="$images.job" draggable="false" />
					</div>
					<span
						:class="{'opacity-06': workplace === 'No Current Position'}"
						:title="workplace"
					>{{workplace}}</span>
				</div>
			</div>
			<div class="detail-item edit">
				<div class="item-wrap">
					<div class="img-wrap">
						<img :src="$images.uni" draggable="false" />
					</div>
					<span :class="{'opacity-06': uni === 'No Information Available'}" :title="uni">{{uni}}</span>
				</div>
			</div>
		</div>
		<div class="bio" v-if="data">
			<span>{{$t('profile.shortBio')}}</span>
			<span>{{data.bio}}</span>
		</div>
		<div v-if="badges.length > 0" class="badges-mobile">
			<UserBadges 
				:badges="badges"
			/>
		</div>
		<div class="socials-wrap" v-if="data">
			<span>{{$t('profile.socialMediaAndWebpage')}}</span>
			<div>
				<img
					:class="{'lower-opacity': !data.socials.facebook}"
					@click="redirect(data.socials.facebook)"
					:src="$images.facebookB"
					draggable="false"
				/>
				<img
					:class="{'lower-opacity': !data.socials.twitter}"
					@click="redirect(data.socials.twitter)"
					:src="$images.twitterB"
					draggable="false"
				/>
				<img
					:class="{'lower-opacity': !data.socials.linkedIn}"
					@click="redirect(data.socials.linkedIn)"
					:src="$images.linkedinB"
					draggable="false"
				/>
				<img
					:class="{'lower-opacity': !data.socials.website}"
					@click="redirect(data.socials.website)"
					:src="$images.websiteB"
					draggable="false"
				/>
			</div>
		</div>
		<div class="contacts-wrap" v-if="data">
			<span>{{$t('profile.contact')}} {{data.name}}</span>
			<div>
				<img
					:class="{'lower-opacity': !data.contacts.email}"
					@click="gotoEmail()"
					:src="$images.mailB"
					draggable="false"
				/>
				<img
					:class="{'lower-opacity': !data.contacts.phone}"
					@click="gotoPhone()"
					:src="$images.phoneB"
					draggable="false"
				/>
				<img
                    v-if="profileId && !(Number(profileId) === Number(userId)) && isLoggedIn && Number(globalFairConfig.FC_CALL) === 1"
					:class="{'lower-opacity': !webRTC}"
					@click="emitVideoCall"
					:src="$images.phoneCall"
					draggable="false"
				/>
				<div class="filler">filler</div>
			</div>
		</div>
		<div class="meeting-wrap" v-if="data">
			<span>{{$t('profile.scheduleAMeeting')}}</span>
			<div>
				<img
					:class="{'lower-opacity': !data.meeting.calendly}"
					@click="redirect(data.meeting.calendly)"
					:src="$images.calendly"
					draggable="false"
				/>
			</div>
		</div>
		<div class="edit-links" v-if="data">
			<button v-if="!profileId" @click="openEditLinks()">{{$t('profile.editLinks')}}</button>
		</div>
		<div class="report-button" v-if="profileId && data" @click="openReportModal">
			<img :src="$images.flag" draggable="false" />
			<span>{{$t('profile.reportProfile')}}</span>
		</div>
		<transition name="chat-fade">
			<div class="background-dim" v-if="isEditLinksOpen || isEditProfileOpen || isReportOpen"></div>
		</transition>
		<transition name="chat-fade">
			<div class="edit-links-wrap" v-if="isEditLinksOpen">
				<editlinks :links="links" @close="closeEditLinks" />
			</div>
		</transition>
		<transition name="chat-fade">
			<div class="edit-profile-wrap" v-if="isEditProfileOpen">
				<editprofile @close="closeEditProfile" />
			</div>
		</transition>
		<transition name="chat-fade">
			<div class="report-profile-wrap" v-if="isReportOpen">
				<reportmodal @close="closeReportModal" :reportdata="reportData" />
			</div>
		</transition>
	</div> -->
  </div>
</template>

<script>
import editlinks from "./EditLinks.vue";
import editprofile from "./EditProfile.vue";
import isMobileMixin from "../../mixins/isMobileMixin.js";
import reportmodal from "../chat/Report.vue";
import UserBadges from "./UserBadges.vue";
import api from "../../api";
import { mapGetters, mapState } from "vuex";
export default {
  components: {
    editlinks,
    editprofile,
    reportmodal,
    UserBadges,
  },
  mixins: [isMobileMixin],
  props: {
    orientation: Boolean,
  },
  data() {
    return {
      isEditLinksOpen: false,
      isEditProfileOpen: false,
      isReportOpen: false,
      data: null,
      reportData: null,
      links: null,
      badges: [],
      imageBaseUrl: process.env.VUE_APP_VIDEO_BASE,
      charts: null,
      userPoints: 0,
    };
  },
  computed: {
    sid() {
      return localStorage.getItem("sid");
    },
    ...mapGetters(["webRTC"]),
    mobile() {
      return this.isMobile;
    },
    profileId() {
      let id = this.$route.params.profile_id;
      if (id && id.includes("-")) {
        id = id.split("-");
        id = id[id.length - 1];
      }
      return id;
    },
    userId() {
      return localStorage.getItem("usr_id");
    },
    cityCountry() {
      let text = "";
      text += this.data.city ? this.data.city + ", " : "";
      text += this.data.country;
      return text;
    },
    workplace() {
      // let dataOther = {
      // 	uni_name: other.uni_name,
      // 	uni_field: other.uni_field,
      // 	grad_year: other.grad_year,
      // 	company_name: other.company_name,
      // 	company_title: other.company_title,
      // 	year_started: other.year_started
      // };
      let other = this.data.other;
      let text = "";
      if (other.company_title) text += other.company_title;
      if (text && other.company_name) text += " @ ";
      if (other.company_name) text += other.company_name;
      if (other.year_started)
        text += " (Started in " + other.year_started + ")";
      if (!text) text = this.$t("profile.noPosition");
      return text;
    },
    uni() {
      let other = this.data.other;
      let text = "";
      if (other.uni_name) text += other.uni_name;
      if (text) text += " - ";
      if (other.uni_field) text += other.uni_field;
      if (other.grad_year) text += " (Graduated in " + other.grad_year + ")";
      if (!text) text = this.$t("profile.noInfo");
      return text;
    },
  },
  watch: {
    profileId() {
      this.init();
    },
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 1000);
  },
  methods: {
    async init() {
      try {
        this.startLoading();
        let res = await api.getProfile(this.profileId);
        this.charts = res.data.user.charts;
        this.userPoints = res.data.point;
        this.badges = res.data.user.badges;
        this.transformData(res.data);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.stopLoading();
      }
    },
    async transformData(data) {
      data = data.user;

      let socials = JSON.parse(data.social);
      socials = socials ? socials : {};

      let other = JSON.parse(data.usr_other);
      other = other ? other : {};

      let dataOther = {
        uni_name: other.uni_name,
        uni_field: other.uni_field,
        grad_year: other.grad_year,
        company_name: other.company_name,
        company_title: other.company_title,
        year_started: other.year_started,
      };
      let dataFormat = {
        id: data.usr_id,
        rol_id: data.rol_id,
        name: data.firstname,
        lastname: data.usr_lastname,
        type: data.type,
        city: data.city,
        country: data.country,
        bio: data.bio,
        online: data.online,
        imageURL: await this.getImageUsdId(data.usd_id),
        socials: {
          facebook: socials.facebook,
          twitter: socials.twitter,
          linkedIn: socials.linkedin,
          website: socials.website,
        },
        contacts: {
          email: data.email,
          phone: socials.phone,
        },
        meeting: {
          calendly: socials.calendly,
        },
        other: dataOther,
        selected: data.selected,
        rol_name: data.rol_name,

        // selected: {
        // 	"Goals for this fair": ["test1", "test2", "test3"],
        // 	"Vlado's interests": [
        // 		"teasdasd asdasdt1",
        // 		"tasd ads est2",
        // 		"tesdaads asd st3",
        // 		"teasda st4",
        // 		"tesadsst5",
        // 		"tedsad asd ast6"
        // 	]
        // }
      };
      if (this.profileId) {
        dataFormat.contacts = {
          email: "",
          phone: "",
        };
      }
      this.data = dataFormat;
      this.links = {
        facebook: socials.facebook,
        twitter: socials.twitter,
        linkedin: socials.linkedin,
        phone: socials.phone,
        calendly: socials.calendly,
        website: socials.website,
      };
    },
    testIfOdd(title) {
      // shows if the given title in selected (goals, interests...) is odd or even
      let current = this.data.selected[title];
      for (let i = 0; i < Object.keys(this.data.selected).length; i++) {
        const element = this.data.selected[Object.keys(this.data.selected)[i]];
        if (element == current && i % 2 == 0) return true;
      }
    },
    openEditLinks() {
      try {
        this.setChat(false);
      } catch (error) {
        this.handleError(error);
      }
      this.isEditLinksOpen = true;
    },
    closeEditLinks() {
      this.isEditLinksOpen = false;
      setTimeout(() => {
        this.init();
      }, 0);
    },
    openEditProfile() {
      try {
        this.setChat(false);
      } catch (error) {
        this.handleError(error);
      }
      this.isEditProfileOpen = true;
    },
    closeEditProfile() {
      this.isEditProfileOpen = false;
      setTimeout(() => {
        this.init();
      }, 0);
    },
    gotoPhone() {
      if (this.data.contacts.phone)
        window.open(`tel:${this.data.contacts.phone}`);
    },
    gotoEmail() {
      if (this.data.contacts.email)
        window.open(`mailto:${this.data.contacts.email}`);
    },
    goToExpo() {
      this.$router.push({ path: "/" });
    },
    redirect(link) {
      // open any given link in seperate tab
      if (link) window.open(link);
    },
    openReportModal() {
      // emit that report modal should be open with profile info
      this.reportData = this.data;
      this.isReportOpen = true;
    },
    closeReportModal() {
      this.isReportOpen = false;
      this.reportData = null;
    },
    openChatModalToDM() {
      // emit that chat should be opened to DM with this user
      let prop = {
        location: "dm",
        userId: this.profileId,
      };
      this.EventBus.$emit("chatProp", prop);
    },
    emitVideoCall() {
      this.EventBus.$emit("make-call", this.profileId);
    },
  },
};
</script>

<style lang="scss" scoped>
/* New styles */

.avatar-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  max-width: 120px;
  .frame {
    position: absolute;
    z-index: 9;
  }
}

.bg-wrap {
  background: #f4f5f7;
  padding-bottom: 5%;
}

.profileRow {
  max-width: 1220px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 2%;
}

.backToFairBtn {
  float: right;
  background: #2295d6;
  border-radius: 2px;
}

.editProfileBtn {
  display: inline-block;
  float: right;
  color: #001529;
}

.editLinksBtn {
  border-radius: 2px;
  color: #001529;
}

.profileCardLeft {
  width: 98%;
  margin-right: 2%;
  border-color: #dfe1e6;
}

.profileCardRight {
  width: 98%;
  margin-left: 2%;
  border-color: #dfe1e6;
  text-align: justify;
}
.badges {
  margin-left: 2%;
  margin-top: 2%;
}
.charts-wrapper {
  margin: 2% 0 0 2%;
  border:1px solid #dfe1e6;
  .header {
    padding: 12px 0 0 0;
    background: #fff;
    h3 {
      margin: 0 0 0 24px;
      padding: 0;
      font-family: "Roboto", sans-serif;
      font-size: 18px;
      line-height: 32px;
      font-weight: 700;
      color: #001529;
      position: relative;
      &::after {
        content: "";
        width: 103%;
        height: 1px;
        background: #dfe1e6;
		position: absolute;
		top: 40px;
		z-index: 999;
		left: -24px;
      }
    }
  }
  .charts {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
.cardNoBorder {
  width: 100%;
  box-shadow: none;
  padding-bottom: 0;
}

.cardNoBorderP16 {
  width: 100%;
  box-shadow: none;
  padding-top: 16px;
  padding-bottom: 16px;
}

.profileTypeBtn {
  display: block;
  margin-bottom: 10px;
  margin-top: 16px;
  margin-left: auto;
  margin-right: auto;
  border-color: #dfe1e6;
  color: #2295d6;
  border-radius: 2px;
}

.profileMainHeading {
  display: inline-block;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  line-height: 32px;
  font-weight: 700;
  color: #001529;
  margin-bottom: 21px;
}

.profileMainContent {
  color: #001529;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 0;
}

.profileSideHeading {
  display: block;
  margin-bottom: 20px;
  color: #001529;
  font-size: 16px;
  line-height: 19px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
}

.profileSideHeadingCenter {
  text-align: center;
  display: block;
  color: #001529;
  font-size: 16px;
  line-height: 19px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  margin-bottom: 0;
}

.blockM16 {
  display: block;
  margin-bottom: 16px;
}

.iconP {
  color: #2295d6;
  display: inline;
  margin-bottom: 0;
  margin-left: 10px;
  font-size: 16px;
  line-height: 19px;
}

.w100p16 {
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
}

.backToFairBtn.mobile {
  display: none;
}

@media only screen and (max-width: 600px) {
  .ant-card-grid {
    text-align: center;
  }

  .ant-card-grid:last-child {
    box-shadow: none;
    display: flex;
    flex-direction: column;
  }

  .profileCardLeft,
  .profileCardRight {
    width: 100%;
    margin: 0;
    border: 0;
  }

  .profileCardRight {
    margin-top: 12px;
  }

  .backToFairBtn {
    display: none;
  }

  .backToFairBtn.mobile {
    display: block;
    margin-top: 16px;
  }
}

/* End of new styles */

.background-dim {
  z-index: 10;
  position: fixed;
  width: 100%;
  height: 100%;
  backdrop-filter: brightness(0.75);
}
@mixin flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@mixin flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@mixin flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

// MOBILE DESIGN

.mobile-background {
  z-index: -1;
  position: absolute;
  top: 00px;
  width: 100%;
  height: 45%;
  background: url("../../assets/backgrounds/visitor-bck.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position-y: -50px;
}
.type-vertical {
  width: 500px;
  position: absolute;
  text-align: right;
  left: -215px;
  top: 225px;
  transform: rotate(-90deg);
  font-weight: 900;
  font-size: 60px;
  color: #ffffff;
  text-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
}
.view-profile-wrap.mobile {
  position: relative;
  overflow-y: auto;
  top: 0;
  right: 0;
  width: unset;
  border-radius: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .pic-socials-wrap .socials-wrap img.lower-opacity,
  .pic-socials-wrap .meeting-wrap img.lower-opacity,
  .pic-socials-wrap .contacts-wrap img.lower-opacity {
    opacity: 0.4;
    cursor: auto;
  }
  &.landscape {
    left: var(--nav-height);
    bottom: 0;
  }
  &.portrait {
    bottom: var(--nav-height);
    left: 0;
  }
  .background-dim {
    position: fixed;
    width: 100%;
    height: 100%;
    backdrop-filter: brightness(0.75);
  }
  .pic-dot-wrap {
    margin-top: 20px;
    height: 130px;
    width: 100px;
    @include flex-center();
    position: relative;
    user-select: none;
    .pic-wrap {
      border-radius: 10px;
      @include flex-center();
      max-height: 130px;
      overflow: hidden;
      img {
        height: 130px;
        max-width: none;
      }
    }
    .green-dot {
      position: absolute;
      width: 15px;
      height: 15px;
      bottom: -7px;
      right: -7px;
      border-radius: 50%;
      background-color: #69d200;
    }
  }
  .full-name {
    z-index: 2;
    margin-top: 30px;
    font-weight: 700;
    font-size: 26px;
    max-width: 90%;
    line-height: 30px;
  }
  .open-chat {
    margin-top: 20px;
    width: 80px;
    height: 30px;
    line-height: 30px;
    background: #f3efef;
    border-radius: 10px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    span {
      color: black;
    }
  }
  .edit-profile {
    cursor: pointer;
    height: 27px;
    margin-top: 20px;
    padding: 2px 10px;
    font-size: 14px;
    width: 100px;
    background: #ffffff;
    border: 1px solid #888c8e;
    box-sizing: border-box;
    border-radius: 9px;
    color: #888c8e;
    font-weight: 700;
  }
  .general-info {
    margin-top: 10px;
    width: 90%;
    @include flex-start();
    flex-direction: column;
    div {
      position: relative;
    }
    .detail-item {
      margin-top: 4px;
      @include flex-between();
      width: 100%;
      .item-wrap {
        max-width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .img-wrap {
          @include flex-center();
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
        .opacity-06 {
          opacity: 0.6;
          font-size: 13px;
        }
        span {
          max-width: calc(100% - 30px);
          line-height: 20px;
        }
      }
    }
  }
  .bio {
    margin-top: 20px;
    @include flex-start();
    flex-direction: column;
    width: 90%;
    span:first-child {
      font-weight: 700;
      font-size: 20px;
      line-height: 20px;
      margin-top: 0;
    }
    span {
      margin-top: 10px;
      font-weight: 300;
      font-size: 13px;
      line-height: 15px;
    }
  }
  .socials-wrap,
  .meeting-wrap,
  .contacts-wrap {
    margin-left: 5%;
    width: 60%;
    align-self: flex-start;
    user-select: none;
    margin-top: 20px;
    @include flex-center();
    flex-direction: column;
    span {
      opacity: 0.6;
      text-align: start;
      font-size: 12px;
      width: 100%;
    }

    div {
      margin-top: 5px;
      @include flex-between();
      width: 100%;
      img {
        cursor: pointer;
        border-radius: 40%;
      }
    }
  }
  .contacts-wrap {
    div.filler {
      width: 40px;
      height: 40px;
      overflow: hidden;
      visibility: hidden;
    }
  }
  .edit-links {
    width: 90%;
    margin: 20px 0;
    button {
      width: 100%;
      cursor: pointer;
      height: 22px;
      padding: 2px 10px;
      font-size: 12px;
      background: #ffffff;
      border: 1px solid #888c8e;
      box-sizing: border-box;
      border-radius: 9px;
      color: #888c8e;
      font-weight: 700;
    }
    button:focus {
      outline: none;
    }
  }
  .report-button {
    @include flex-start();
    margin: 20px 0;
    cursor: pointer;
    user-select: none;
    img {
      width: 15px;
      height: 15px;
      margin-right: 10px;
    }
    span {
      opacity: 0.5;
    }
  }
  .edit-links-wrap {
    z-index: 12;
    position: fixed;
    width: 90%;
    height: 80%;
  }
  .badges-mobile {
    padding: 0 20px;
  }
}

// WEB Design
.view-profile-wrap {
  width: 82%;
  height: 100%;
  // background-color: white;
  @include flex-start;

  .pic-socials-wrap .socials-wrap img.lower-opacity,
  .pic-socials-wrap .meeting-wrap img.lower-opacity,
  .pic-socials-wrap .contacts-wrap img.lower-opacity {
    opacity: 0.4;
    cursor: auto;
  }

  .pic-socials-wrap {
    user-select: none;
    height: calc(100% - 65px);
    position: relative;
    padding-left: 7%;
    padding-top: 70px;
    width: 25%;
    min-width: 260px;
    // overflow: auto;
    img {
      width: 40px;
      height: 40px;
    }
    .open-chat {
      cursor: pointer;
      margin: 20px 0;
      background-color: #f3efef;
      height: 35px;
      border-radius: 10px;
      @include flex-between();
      span {
        margin: 0 10px;
      }
      span.material-icons {
        font-size: 18px;
      }
    }
    .pic-dot-wrap {
      min-height: 200px;
      @include flex-center();
      position: relative;
      user-select: none;
      .pic-wrap {
        @include flex-center();
        max-height: 300px;
        overflow: hidden;
        img {
          height: auto;
          width: auto;
        }
      }
      .green-dot {
        position: absolute;
        width: 20px;
        height: 20px;
        bottom: -7px;
        right: calc((100% - 200px) / 2 - 10px);
        border-radius: 50%;
        background-color: #69d200;
      }
    }
    .socials-wrap,
    .meeting-wrap,
    .contacts-wrap {
      user-select: none;
      margin-top: 20px;
      @include flex-center();
      flex-direction: column;
      span {
        opacity: 0.6;
        text-align: start;
        font-size: 12px;
        width: 100%;
      }

      div {
        margin-top: 5px;
        @include flex-between();
        width: 100%;
        img {
          cursor: pointer;
          border-radius: 40%;
        }
      }
    }
    .contacts-wrap {
      div.filler {
        width: 40px;
        height: 40px;
        overflow: hidden;
        visibility: hidden;
      }
    }
    .edit-links {
      margin-top: 20px;
      button {
        cursor: pointer;
        height: 22px;
        padding: 2px 10px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #888c8e;
        box-sizing: border-box;
        border-radius: 9px;
        color: #888c8e;
        font-weight: 700;
      }
      button:focus {
        outline: none;
      }
    }
    .report-button {
      @include flex-start();
      margin: 50px 0;
      cursor: pointer;
      user-select: none;
      img {
        width: 15px;
        height: 15px;
        margin-right: 10px;
      }
      span {
        opacity: 0.5;
      }
    }
  }
  .info-goals-interests-wrap {
    @include flex-start();
    flex-direction: column;
    width: 69%;
    min-width: 400px;
    height: 100%;
    padding-left: 4%;
    padding-top: 30px;
    box-sizing: border-box;
    overflow-y: auto;
    .navbar {
      @include flex-end();
      user-select: none;
      color: #6f6f6f;
      height: 40px;
      width: 100%;
      div {
        @include flex-center();
        cursor: pointer;
      }
      .material-icons {
        transform: rotate(180deg);
        font-size: 15px;
        padding: 1px;
        font-weight: 900;
        border-radius: 50%;
        border: 2px solid #6f6f6f;
        margin-left: 10px;
      }
    }
    .general-info {
      width: 100%;
      @include flex-start();
      flex-direction: column;
      div {
        position: relative;
      }
      .type {
        z-index: -1;
        user-select: none;
        top: -10%;
        font-weight: 900;
        font-size: 100px;
        color: #e0e0e0;
      }
      .full-name {
        top: -10px;
        font-weight: 900;
        font-size: 32px;
      }
      .detail-item {
        @include flex-between();
        width: 100%;
        .item-wrap {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .img-wrap {
            @include flex-center();
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
          .opacity-06 {
            opacity: 0.6;
            font-size: 13px;
          }
          span {
            max-width: 330px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .detail-item.edit {
        button.edit-profile {
          cursor: pointer;
          height: 22px;
          padding: 2px 10px;
          font-size: 12px;
          background: #ffffff;
          border: 1px solid #888c8e;
          box-sizing: border-box;
          border-radius: 9px;
          color: #888c8e;
          font-weight: 700;
        }
        button:focus {
          outline: none;
        }
      }
    }
    .general-info::after {
      margin-top: 10px;
      content: "";
      width: 100%;
      height: 1px;
      background-color: #bdbdbd;
    }
    .bio {
      @include flex-start();
      flex-direction: column;
      margin-top: 20px;
      span:first-child {
        font-weight: 900;
        font-size: 20px;
        margin-bottom: 10px;
      }
      span:nth-child(2) {
        font-weight: 300;
        font-size: 13px;
      }
    }
    @mixin goal-interest-wrap {
      height: 30px;
      font-weight: 700;
      letter-spacing: 1px;
      border-radius: 10px;
      color: white;
      @include flex-center();
      padding: 5px 25px;
      margin: 5px 20px 5px 0;
    }
    .goals {
      @include flex-start();
      flex-wrap: wrap;
      div {
        @include goal-interest-wrap;
        background: #f4aa33;
      }
    }
    .interests-title,
    .goals-title {
      font-weight: 700;
      font-size: 20px;
      margin: 30px 0 10px 0;
    }
    .interests {
      @include flex-start();
      flex-wrap: wrap;
      div {
        @include goal-interest-wrap;
        background: #d35b30;
      }
    }
    .selected-warp {
      margin-top: 20px;
      .multi-select {
        width: 100%;
        padding: 10px 0;
        span {
          font-weight: 700;
          font-size: 20px;
          margin: 30px 0 10px 0;
        }
        .items-wrap {
          @include flex-start();
          flex-wrap: wrap;
          div {
            @include goal-interest-wrap;
            background: #d35b30;
          }
          div.test {
            background: #f4aa33;
          }
        }
      }
    }
  }
}
</style>